import React from 'react';
import './TableSelectionModal.css';

const TableSelectionModal = ({ tables, selectedTable, onSelect, onClose }) => {
  const getTableStatus = (table) => {
    if (table.status === 'occupied') return 'occupied';
    if (table.status === 'reserved') return 'reserved';
    return 'available';
  };

  const groupedTables = tables.reduce((acc, table) => {
    const area = table.area || 'Main Area';
    if (!acc[area]) acc[area] = [];
    acc[area].push(table);
    return acc;
  }, {});

  return (
    <div className="table-modal-overlay" onClick={onClose}>
      <div className="table-modal" onClick={(e) => e.stopPropagation()}>
        <div className="table-modal-header">
          <h2>Select Table</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="table-modal-body">
          {Object.entries(groupedTables).map(([area, areaTables]) => (
            <div key={area} className="table-area-group">
              <h3 className="area-title">{area}</h3>
              <div className="tables-grid">
                {areaTables.map(table => {
                  const status = getTableStatus(table);
                  const isSelected = selectedTable?.id === table.id;

                  return (
                    <button
                      key={table.id}
                      className={`table-card ${status} ${isSelected ? 'selected' : ''}`}
                      onClick={() => status === 'available' && onSelect(table)}
                      disabled={status !== 'available'}
                    >
                      <div className="table-icon">🪑</div>
                      <div className="table-info">
                        <span className="table-number">Table {table.number}</span>
                        {table.capacity && (
                          <span className="table-capacity">{table.capacity} seats</span>
                        )}
                      </div>
                      <div className={`table-status-badge ${status}`}>
                        {status === 'available' && '✓ Available'}
                        {status === 'occupied' && '⊗ Occupied'}
                        {status === 'reserved' && '⊙ Reserved'}
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}

          {tables.length === 0 && (
            <div className="no-tables">
              <p>No tables available</p>
              <small>Please contact admin to add tables</small>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableSelectionModal;
